export const productManager = {
  id: 'product-manager',
  version: 2,
  renderer: 'enterprise',
  name: 'Product Manager Leader',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['consulting'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 40,
    visual: 25,
    executive: 25,
    student: 10
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills'],
  components: {
    header: 'header-executive',
    experience: 'experience-metrics',
    projects: 'projects-case-study',
    skills: 'skills-categorized',
    education: 'education-classic'
  },
  metadata: {
    industry: ['Tech Product Management', 'SaaS', 'E-Commerce'],
    companies: ['Google', 'Meta', 'Amazon', 'Atlassian', 'Adobe', 'Stripe', 'HubSpot'],
    ats: ['Greenhouse', 'Lever', 'Workday'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: true,
    density: 'comfortable',
    columns: 1,
    experienceLevel: ['Mid-level', 'Senior', 'Lead'],
    careerStage: 'Professional',
    recommendedFor: ['Product Managers', 'Technical Product Managers', 'Product Owners', 'Program Managers'],
    avoidFor: ['Investment Bankers', 'Federal Clerks', 'Graphic Designers'],
    dna: ['Product-Centric', 'ATS-Scannable', 'Balanced-Whitespace', 'Inter-Sans', 'Corporate-Modern'],
    metrics: {
      readingDifficulty: 95,
      scanningSpeed: 96,
      visualAppeal: 88
    },
    hiringManager: {
      firstImpression: "Structured, business-aligned product leader with a focus on metrics and results",
      scanningStyle: "Linear scanning focusing on product launches, revenue metrics, and user growth figures",
      preferredStructure: "Summary, experience, projects, education, skills",
      dislikes: ["Objective statements", "Soft skills self-ratings", "No links to live products/projects"]
    },
    strategy: {
      goal: "Pass standard tech ATS checks and highlight feature ownership and product success metrics",
      focus: "Feature launch metrics (e.g. user adoption, conversion rate increases) and technical collaboration",
      avoid: ["Traditional serif fonts", "Complex graphics blocks"]
    },
    psychology: {
      coreTraits: ["Ownership", "Innovation", "Data-centric execution", "Collaboration"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Start every bullet with strong action verbs (e.g. 'launched', 'drove', 'collaborated'). Quantify achievements (e.g. 'increased conversion rate by 18%', 'scaled active users to 2M+'). Reference product frameworks and lifecycle.",
      rewriteStyle: "Product-minded, result-oriented, concise"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'projects', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '22px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '22px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2C3E50',
    '--color-text-light': '#7F8C8D'
  }
};
export default productManager;
